"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLockScroll = void 0;
const lodash_1 = require("lodash");
const react_1 = require("react");
const scroll_lock_1 = require("scroll-lock");
const utils_1 = require("@hivebrite/utils");
// Distance from the top of the screen to the focused element. Works only for mobile.
const SCROLL_MARGIN = 80;
const getScreenY = (el) => (0, lodash_1.get)(el, 'y');
const useLockScroll = ({ enabled = true, ref, scrollTo = [], }) => {
    const disabledRef = (0, react_1.useRef)(false);
    const origScroll = (0, react_1.useMemo)(() => [
        (typeof window === 'undefined' ? 0 : window.scrollX,
            typeof window === 'undefined' ? 0 : window.scrollY),
    ], []);
    const isMobileDevice = Boolean(utils_1.mobileDeviceFromUserAgent.any());
    const focusListener = (0, react_1.useCallback)((e) => {
        if (e.target instanceof HTMLElement &&
            e.target.matches('input, textarea, [contenteditable]')) {
            setTimeout(() => {
                if (!ref || !ref.current) {
                    return;
                }
                if (typeof window !== 'undefined') {
                    window.scrollTo({
                        left: scrollTo[0],
                        top: scrollTo[1],
                    });
                }
                const scrollToTop = getScreenY(e.target.getBoundingClientRect()) -
                    getScreenY(ref.current.getBoundingClientRect()) +
                    ref.current.scrollTop -
                    SCROLL_MARGIN;
                ref.current.scrollTo({
                    behavior: 'smooth',
                    left: 0,
                    top: Math.max(scrollToTop, 0),
                });
            }, 250);
        }
    }, [ref, scrollTo]);
    (0, react_1.useEffect)(() => {
        let timer;
        if (enabled && !disabledRef.current) {
            if (!(0, lodash_1.isEmpty)(scrollTo) && isMobileDevice && (ref === null || ref === void 0 ? void 0 : ref.current)) {
                ref.current.addEventListener('focus', focusListener, true);
                timer = setTimeout(
                // Force as number since we know it's not empty (see above)
                () => ref.current &&
                    window.scrollTo(scrollTo[0], scrollTo[1]), 100);
            }
            (0, scroll_lock_1.disablePageScroll)((ref === null || ref === void 0 ? void 0 : ref.current) || undefined);
            disabledRef.current = true;
        }
        const currentRef = ref === null || ref === void 0 ? void 0 : ref.current;
        return () => {
            clearTimeout(timer);
            if (disabledRef.current) {
                (0, scroll_lock_1.enablePageScroll)(currentRef || undefined);
                if (!(0, lodash_1.isEmpty)(scrollTo) && isMobileDevice && currentRef) {
                    currentRef.removeEventListener('focus', focusListener, true);
                    setTimeout(() => window.scrollTo(origScroll[0], origScroll[1]), 100);
                }
                disabledRef.current = false;
            }
        };
    }, [
        disabledRef,
        enabled,
        focusListener,
        isMobileDevice,
        origScroll,
        ref,
        scrollTo,
    ]);
};
exports.useLockScroll = useLockScroll;
//# sourceMappingURL=index.js.map